import { Form } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useListLocationConditionsQuery } from '../../../../../../api/queries/listLocationConditions';
import { useThemeComponents } from '../../../../../../themes';

type LocationDeleteModalProps = {
    locationId: string;
    openModal: boolean;
    close: () => void;
    removeRow: () => void;
};

export const useLocationDeleteModal = () => {
    const [openModal, setOpenModal] = useState<boolean>(false);

    const action = useMemo(
        () => ({
            open: () => setOpenModal(true),
            close: () => {
                setOpenModal(false);
            },
            render: (locationId: string, removeRow: () => void) => (
                <LocationDeleteModal
                    close={() => setOpenModal(false)}
                    locationId={locationId}
                    openModal={openModal}
                    removeRow={removeRow}
                />
            ),
        }),
        [openModal]
    );

    return { ...action };
};

const LocationDeleteModal = ({ locationId, openModal, close, removeRow }: LocationDeleteModalProps) => {
    const { t } = useTranslation(['mobilityModuleDetails']);
    const { Modal } = useThemeComponents();

    const { data } = useListLocationConditionsQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            locationId,
        },
        skip: !locationId,
    });

    const affectedConditions = useMemo(() => data?.list, [data?.list]);

    return (
        <Modal
            cancelText={t('mobilityModuleDetails:modal.deleteLocation.cancelText')}
            okText={t('mobilityModuleDetails:modal.deleteLocation.okText')}
            onCancel={close}
            onOk={() => {
                close();
                removeRow();
            }}
            open={openModal}
            title={t('mobilityModuleDetails:modal.deleteLocation.title')}
            destroyOnClose
        >
            <Form layout="vertical">
                {t('mobilityModuleDetails:modal.deleteLocation.description')}
                <ol style={{ marginTop: '10px' }}>
                    {(affectedConditions || []).map(feature => (
                        <li>{feature}</li>
                    ))}
                </ol>
            </Form>
        </Modal>
    );
};

export default LocationDeleteModal;
